import type { Call } from '../../entities/call/callTypes';
import { MOCK_GROUP_ID } from './mockSite';

/**
 * Dataset mock per Call. Audit allineato a mockTasks/mockNotes (userId 1
 * = "Jader Francia"). callDate distribuite su 4 mesi per popolare la
 * timeline. Mix IN/OUT e status differenti per testare i filtri.
 *
 * Le Relationship Call <-> Person/Business sono in relationshipMocks.ts.
 */
const baseAudit = { companyId: 1, groupId: MOCK_GROUP_ID, userId: 1, userName: 'Jader Francia' };
const auditAt = (iso: string) => ({ ...baseAudit, createDate: iso, modifiedDate: iso });

export const mockCalls: Call[] = [
  // --- Aprile 2026 ---
  {
    callId: 1,
    direction: 'OUT',
    callDate: '2026-04-10T09:30:00Z',
    description: 'Follow-up commerciale Fornari Srl: il cliente conferma interesse, richiede secondo incontro tecnico entro fine aprile.',
    actionItems: 'Fissare il secondo incontro tecnico entro fine aprile.\nPreparare la scheda prodotto aggiornata da portare in riunione.',
    status: 'connected',
    ...auditAt('2026-04-10T09:30:00Z'),
  },
  {
    callId: 2,
    direction: 'IN',
    callDate: '2026-04-05T14:15:00Z',
    description: 'Acme Corp - Michele Placido ha chiamato per dettagli sul preventivo. Risposta data: invio documentazione tecnica entro venerdì.',
    status: 'connected',
    internalExtension: '214',
    internalName: 'Jader Francia',
    ...auditAt('2026-04-05T14:15:00Z'),
  },
  {
    callId: 3,
    direction: 'OUT',
    callDate: '2026-04-03T11:00:00Z',
    description: 'Tentativo di contatto Eugenio Fornari per chiarimento ordine.',
    status: 'no-response',
    ...auditAt('2026-04-03T11:00:00Z'),
  },

  // --- Marzo 2026 ---
  {
    callId: 4,
    direction: 'OUT',
    callDate: '2026-03-22T16:00:00Z',
    description: 'Lasciato messaggio in segreteria a Roberto Bianchi (Miksi). Richiamare lunedì mattina.',
    status: 'message',
    ...auditAt('2026-03-22T16:00:00Z'),
  },
  {
    callId: 5,
    direction: 'IN',
    callDate: '2026-03-18T10:30:00Z',
    description: 'Elena Marchetti (Giubra) ha confermato la disponibilità per la riunione del 25 marzo.',
    status: 'connected',
    internalExtension: '207',
    ...auditAt('2026-03-18T10:30:00Z'),
  },
  {
    callId: 6,
    direction: 'OUT',
    callDate: '2026-03-10T09:00:00Z',
    description: 'Numero non corretto - il vecchio numero di Trentino Sicurezza non è più attivo. Da aggiornare in anagrafica.',
    status: 'wrong-number',
    ...auditAt('2026-03-10T09:00:00Z'),
  },
  {
    callId: 7,
    direction: 'OUT',
    callDate: '2026-03-05T15:45:00Z',
    description: 'Centralino occupato - riprovare domani mattina.',
    status: 'busy',
    ...auditAt('2026-03-05T15:45:00Z'),
  },

  // --- Febbraio 2026 ---
  {
    callId: 8,
    direction: 'IN',
    callDate: '2026-02-20T11:15:00Z',
    description: 'Giulia Ferri (Edilizia Moderna) ha chiamato per chiarimenti su tempistiche progetto. Risposta: invio piano dettagliato entro 48h.',
    actionItems: 'Inviare il piano dettagliato delle tempistiche entro 48h.\nCoinvolgere il project manager per la stima delle fasi.',
    status: 'connected',
    ...auditAt('2026-02-20T11:15:00Z'),
  },
  {
    callId: 9,
    direction: 'OUT',
    callDate: '2026-02-08T14:00:00Z',
    description: 'Confermato appuntamento on-site con Marco Zanetti (Trentino Sicurezza) per il 15 febbraio.',
    status: 'connected',
    ...auditAt('2026-02-08T14:00:00Z'),
  },

  // --- Gennaio 2026 ---
  {
    callId: 10,
    direction: 'OUT',
    callDate: '2026-01-25T10:00:00Z',
    description: 'Thomas Huber (AlpiSolar) - discussione progetto pilot per il mercato austriaco. Apertura positiva, follow-up con offerta tecnica.',
    actionItems: 'Preparare l\'offerta tecnica per il pilot austriaco.\nVerificare le certificazioni richieste per il mercato AT.',
    status: 'connected',
    ...auditAt('2026-01-25T10:00:00Z'),
  },
];
